module.exports = __webpack_public_path__ + "static/media/mini-bus.bb5ab78c.png";